import { Card, CardBody, Col, Container, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import { useQuery } from "react-query";
import LoadingMask from "../../components/form_masks/share/LoadingMask";
import ErrorMask from "../../components/form_masks/share/ErrorMask";
import { FaFilePdf } from "react-icons/fa";
import { useState } from "react";

const FormularePage = () => {

    const API = new PrivateApi();
    const [pdf, setPdf] = useState("");

    const {data, error, isLoading} = useQuery("GET_HV_FORMULARS", API.hw_formulars_active, {staleTime: Infinity});

    if (isLoading) return <LoadingMask />;
    if (error) return <ErrorMask error={error} />;

    const downloadFormular = (fid) => {
        API.hw_formular_download(fid)
            .then(res => {
                const base64 = res.data.file;

                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/pdf"});

                // create anchor and download
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = res.data.file_name;  // filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // cleanup
                setTimeout(() => URL.revokeObjectURL(link.href), 60_000);
            });
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h3>Formulare</h3>
                    <p className="text-muted">
                        Hier finden Sie die Anmeldeformulare für ENERGO Endkunden
                    </p>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <Card className="shadow-lg">
                        <CardBody>
                            <ListGroup>
                                {data && data.data.length > 0 &&
                                    data.data.map(formular => (
                                        <ListGroupItem action onClick={() => downloadFormular(formular.id)}>
                                            <div className="d-flex gap-2">
                                                <FaFilePdf className="text-danger" size={30} />
                                                {formular.name}
                                            </div>
                                        </ListGroupItem>
                                    ))
                                }
                            </ListGroup>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div>
                {pdf !== "" &&
                    pdf
                }
            </div>
        </Container>
    )
}
export default FormularePage;